import { Plan } from '../model/plan.model';
import { Energy } from '../model/energy.model';
import { createDateTime, FORMAT_TIMESTAMP } from '../utils/dateFormatter';

export const planFactory = {
    create: (id, name, energy, time, comment, foods, products, date = null) => {
      return new Plan(
        id,
        name,
        new Energy(energy),
        time,
        comment,
        foods,
        products,
        createDateTime(date, time).format(FORMAT_TIMESTAMP),
      );
    },
    createFromDto: (planDto) => {
      return this.create(
        planDto.id,
        planDto.name,
        planDto.prescribedEnergy.amount,
        planDto.time,
        planDto.comment,
        planDto.foods,
        planDto.products,
      );
    },
  }
;
